import { useRecordTags } from "../hooks/useRecordTags.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Records/shared/RecordTagTitles.tsx
var RecordTagTitles = ({ listAll = true, recordTagIds }) => {
	const { data, loading } = useRecordTags({ idFilter: recordTagIds }, { cacheStrategy: "cache-only" });
	if (!data?.tags && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.tags || !recordTagIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.tags[0].title
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.tags.map(({ title }) => title).join(", ") });
};
//#endregion
export { RecordTagTitles };

//# sourceMappingURL=RecordTagTitles.js.map